import { useCallback, useState } from "react";
import "./App.css";
import AppRouter from "./AppRouter";
import Alert from "./components/Alert";
function App() {
  // qwerty123
  // admin@gmail.com

  const [alertData, setAlertData] = useState({});
  const addAlertText = useCallback((payload) => {
    setAlertData(() => payload);
  }, []);

  return (
    <div className="App d-flex justify-content-center">
      <Alert payload={alertData} />
      <AppRouter addAlertText={addAlertText} />

    </div>
  );
}

export default App;
